import { motion } from "framer-motion";
import { TEAM, TEAM_ROSTER } from "@/data/content";
import { SectionLabel, Reveal } from "@/components/site/primitives";

export const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="mx-auto max-w-[1400px] px-5 md:px-10 py-28 md:py-44"
    >
      <SectionLabel index="[ 08 ]" testId="team-label">
        Leadership
      </SectionLabel>

      {/* Founder video */}
      <Reveal className="mb-16 md:mb-24 border border-epic-line bg-epic-surface">
        <div className="grid md:grid-cols-12" data-testid="founder-block">
          <div className="md:col-span-5 p-6 md:p-10 flex flex-col justify-center">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-epic-accent mb-4">
              From the Founder
            </p>
            <h3 className="font-grotesk font-bold uppercase tracking-tight text-2xl md:text-3xl text-epic-text leading-[0.95]">
              Carter Wilcoxson on the vision behind ePIC
            </h3>
            <p className="font-mono text-sm text-epic-sub mt-4 leading-relaxed">
              A short message from the CEO &amp; Founder on why ePIC exists — and what your investment makes possible.
            </p>
          </div>
          <div className="md:col-span-7 border-t md:border-t-0 md:border-l border-epic-line">
            <video
              data-testid="founder-video"
              controls
              preload="metadata"
              playsInline
              poster="/team/carter.png"
              className="w-full aspect-video bg-black object-cover"
            >
              <source
                src="https://content.bombbomb.com/fdcf9f89-1d33-4658-9d63-a7639044dc38_H264Main.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {[...TEAM].sort((a, b) => (a.order ?? 999) - (b.order ?? 999)).map((member, i) => (
          <motion.div
            key={member.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="group border border-epic-line bg-epic-surface"
            data-testid={`team-member-${i}`}
          >
            <div className="relative overflow-hidden aspect-[4/5]">
              <img
                src={member.img}
                alt={member.name}
                className="w-full h-full object-cover grayscale contrast-110 transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-epic-surface via-transparent to-transparent opacity-80" />
            </div>
            <div className="p-6 md:p-8">
              <h3 className="font-grotesk font-bold uppercase tracking-tight text-xl md:text-2xl text-epic-text">
                {member.name}
              </h3>
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-epic-accent mt-2">
                {member.role}
              </p>
              <p className="font-mono text-sm text-epic-sub mt-4 leading-relaxed">
                {member.bio}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Advisors & team roster */}
      {TEAM_ROSTER.length > 0 && (
      <div className="mt-4 md:mt-6 border border-epic-line bg-epic-surface p-6 md:p-10">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-epic-sub mb-8">
          Advisors & Team
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {TEAM_ROSTER.map((m) => (
            <div key={m.name} className="border-t border-epic-line pt-4" data-testid={`roster-${m.name}`}>
              <p className="font-grotesk font-bold uppercase tracking-tight text-base text-epic-text">
                {m.name}
              </p>
              <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-epic-accent mt-1">
                {m.role}
              </p>
            </div>
          ))}
        </div>
      </div>
      )}
    </section>
  );
};
